function Sendmessage () {
    return (
        <div className="bg-white w-full py-5 px-5 text-left">
            <p className="text-left">Send Email</p>
            <div className="mt-3 ml-52">
                <lable for="sendid" className="mr-2">Send ID</lable>
                <input type="email" name="sendid" placeholder="SanielDan" disable className="placeholder:text-gray-900 bg-white w-96 h-10 rounded placeholder:text-lg px-2"/>
            </div>

            <div className="mt-3 ml-40">
                <lable for="sendto" className="mr-2.5">Send To Email</lable>
                <input type="text" name="sendto" placeholder="Type the receiver email address" className="placeholder:text-gray-900 bg-white w-96 h-10 rounded placeholder:text-lg px-2"/>
            </div>

            <div className="mt-3 ml-24">
                <lable for="receiverphoneNumber" className="mr-2.5">Receiver phoneNumber</lable>
                <input type="text" name="receiverphoneNumber" className="placeholder:text-gray-900 bg-white w-96 h-10 rounded placeholder:text-lg px-2"/>
            </div>

            <div className="mt-3 ml-48 pl-1.5">
                <lable for="message" className="mr-2.5 absolute">Message</lable>

                <textarea rows="100" cols="50" name="message"  className="placeholder:text-gray-900 bg-white w-96 h-60 rounded placeholder:text-lg px-2 ml-20 border-2 border-gray-900">...Type your message here</textarea>

            </div>



            <div className="mt-3 ml-52">
                <button className="bg-green-500 text-white py-2 px-2 rounded">Confirm</button>
                <button className="bg-gray-900 ml-5 text-white py-2 px-2 rounded">Cancel</button>
            </div>
        </div>
    )
}

export default Sendmessage